export default "__VITE_ASSET__379f3ebe__"